module.exports = __webpack_public_path__ + "iconfont.svg?9df776fc48542e6eefa4869722fb14a3";


//////////////////
// WEBPACK FOOTER
// ./src/font/iconfont.svg?t=1573030555456
// module id = 22
// module chunks = 0